import type {ImgHTMLAttributes} from 'react'
import React from 'react'

export function IconAmazonLogo({...attributes}: ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <img
      width="49px"
      height="15px"
      {...attributes}
      alt="amazon-logo"
      src="https://dt47coepsakuj.cloudfront.net/images/amazon-logo.png"
    />
  )
}
